/* tslint:disable */

/**
 */
export class RouteInput {
    style_search?: string;
    key_input?: string;
}
